import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { FormikInputTypeAhead, LabeledButtonMultiple, ButtonText, FormikInputText } from "@loanbossinc/component-library";


export const StyledLabeledButtonMultiple = styled(LabeledButtonMultiple)`
  margin-top: 2em;
  margin-left: 38px
`;

export const StyledLeftContainer = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;
export const StyledLeftChildContainer = styled.div`
display: flex;
flex-direction: row;
width: 100%;
`;
export const Frame = styled.div`
width:1150px;
background-color: #FAFAFA;
position: absolute;
right: ${props => props.sidePanelSize()};
box-shadow: -5px 0 8px #dadce0;
border: 1px solid #DADCE0;
transition: all .5s ease;
`;
export const StyledButtonContainer = styled.div`{
display: flex;
flex: 1;
justify-content: end;
}`;

export const StyledButtonText = styled(ButtonText)`
&& {
  display: flex;
  flex: 2;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 16px;
  .label {
    margin-left: 14px;
  }
}
`;
export const StyledQuoteGrid = styled(Grid)`
&& {
  border: 1px solid #DADCE0;
}
`;
export const EmptyWrapper = styled.div`
height: 294px;
width: 294px;
left: 989px;
top: 467px;
border-radius: 50%;
background: linear-gradient(217.82deg, rgba(79, 129, 157, 0.1) 6.94%, rgba(249, 249, 249, 0) 90.56%);
`;
export const ImageContainer = styled.div`
text-align: center;
display: block;
margin-top: 65px;
`;
export const NoQuotesTextWrapper = styled.div`
/* No notes attached to this deal */
width: 369px;
height: 19px;

/* Work Sans / 16 Regular */
font-family: Work Sans;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 19px;

/* identical to box height */
display: flex;
align-items: center;
text-align: right;

/* Fill / Dark Gray */
color: #5F6368;  
`;
export const ButtonIconContainer = styled.div`
float: right;
margin-top:14px;
`;
export const emptyNote = process.env.PUBLIC_URL + "/images/DollarSignEmpty.png";
export const QUOTE_PANEL = "QUOTE_PANEL";
export const TERM_SHEET_PANEL = "TERM_SHEET_PANEL";
export const COMPARE_LOANS_MODAL = "COMPARE_LOANS_MODAL";
export const ANALYSIS_MODAL = "ANALYSIS_MODAL";
export const COMBINE_LOANS_MODAL = "COMBINE_LOANS_MODAL";
export const REQUEST_NEW_CONTACT_MODAL = "REQUEST_NEW_CONTACT_MODAL";
export const SIMPLE_INFO_MODAL = "SIMPLE_INFO_MODAL";
export const PICK_A_WINNER_MODAL = "PICK_A_WINNER_MODAL";

export const StyledCompanyNameContaner = styled.div`&{
  /* Work Sans / 24 */

  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  align-items: center;
  text-align: center;
  
  color: #000000;

  margin-top: 36px;
}`;
export const StyledSubmittedByContaner = styled.div`&{
  /* Work Sans / 14 Regular */
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  
  /* Fill / Dark Gray */  
  color: #5F6368;

  margin-top: 10px;
}`;

export const Divider = styled.div`&& {    
  border: 1px solid #DADCE0;
  width: 100%;
  height: 0px;
  margin-top:30px;
}`;

export const StyledGridContainer = styled(Grid)`&&{
  margin-top: 26px
}`;

export const StyledFormikInputText = styled(FormikInputText)`&&&&{
  width: 100%
}`;

export const StyledFormikInputTypeAhead = styled(FormikInputTypeAhead)`
  border-bottom: 1px solid #2196F3;
  width: 100%;
`;
